import axios from 'axios'
import router from '@/router'
import toast from '@/utils/toast'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '',
  timeout: 15000
})

service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('al_web_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      config.headers.token = token
    }
    return config
  },
  (error) => Promise.reject(error)
)

function rejectBiz(msg, code) {
  const text = msg || '请求失败'
  // 业务错误用 warning，更符合「提醒」；硬错误再用 error
  if (code === 401 || code === 403 || code === 422) {
    toast.warning(text)
  } else {
    toast.error(text)
  }
  const err = new Error(text)
  err.code = code
  err.__toastShown = true
  return Promise.reject(err)
}

service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res && typeof res.code !== 'undefined' && res.code !== 0) {
      if (res.code === 401) {
        localStorage.removeItem('al_web_token')
        if (router.currentRoute.value.name !== 'login') {
          router.push({ name: 'login', query: { redirect: router.currentRoute.value.fullPath } })
        }
      }
      return rejectBiz(res.msg || '请求失败', res.code)
    }
    return res
  },
  (error) => {
    // 已在业务分支提示过则直接抛出
    if (error?.__toastShown) {
      return Promise.reject(error)
    }
    const status = error.response?.status
    const msg = error.response?.data?.msg || error.message || '网络异常'
    if (status === 401) {
      localStorage.removeItem('al_web_token')
      if (router.currentRoute.value.name !== 'login') {
        router.push({ name: 'login', query: { redirect: router.currentRoute.value.fullPath } })
      }
    }
    toast.error(msg)
    error.__toastShown = true
    return Promise.reject(error)
  }
)

export default service
